import React from 'react'
import ItemViewLeftMenuItem from "../../../../item-view/@core/components/menu-item/menu-item"
import Message from "../../../model2/message/message"
import UserIcon from "../../../gd-components/icons/user/user"
import formatTime from "../../../gd/format/time"
import formatDate from "../../../gd/format/date"

type Props = {
    message: Message
}

const debug = false
// const debug = "MessageEditLeftPanel"

export default function MessageEditLeftPanel(props:Props) {

    debug && console.log(debug, 'render', props)

    const onDelete = () => {
        debug && console.log(debug, 'onDelete', props)
    }

    // @ts-ignore
    const createdByUser = gd.session.users.get(props.message.fromUserId)

    let lastUpdatedTimeLabel
    if (props.message.lastUpdatedTime.isSame(moment(),'day')) {
        lastUpdatedTimeLabel = formatTime(props.message.lastUpdatedTime)
    } else {
        lastUpdatedTimeLabel = formatDate(props.message.lastUpdatedTime)
    }

    return (
        <div className="iv-left-column iv-column">
            <div className="details-big-icon">
                <div className="center-icon">
                    <div className={Classes("ui5-ico-custom-field bg-gray s-72 i5-pen")}/>
                </div>
            </div>

            <div className="flex-row-between-center h-32 p-l-20 p-r-20">
                <div className="ui5-txt-not-important-tiny flex-no-shrink m-r-10">Created by:</div>
                <div className="flex-row-left-center txt-truncate">
                    <UserIcon className = "m-r-5 flex-no-shrink"
                              size      = "22"
                              userId    = {props.message.fromUserId!}/>
                    <div className="ui5-txt-less-important-small txt-truncate">
                        {createdByUser!.name}
                    </div>
                </div>
            </div>

            <div className="flex-row-between-center h-32 p-l-20 p-r-20">
                <div className="ui5-txt-not-important-tiny flex-no-shrink m-r-10">Last updated:</div>
                <div className="ui5-txt-less-important-small flex-row-left-center txt-truncate">
                    {lastUpdatedTimeLabel}
                </div>
            </div>

            <div className="ui5-menu p-t-0">
                <div className="separator-h"/>

                <div className="menu-section open">
                    <ItemViewLeftMenuItem className="red"
                                          item={{icon: 'i5-trash-alt', label: 'Delete'}}
                                          onClick={onDelete}/>
                </div>
            </div>

            {/*<div className="bottom-actions with-separator">
                <div className="ui5-menu">
                    <ItemViewLeftMenuItem className="red"
                                          item={{icon: 'i5-trash-alt', label: 'Delete'}}
                                          onClick={onDelete}/>
                </div>
            </div>*/}
        </div>
    );
}
